import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import SectionHeading from "@/components/base/SectionHeading";

export default function TopicSection() {
  const list = topics.filter((topic) => topic.slug !== "all");

  return (
    <section id="topics" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          kicker="TOPICS"
          title="主题分类"
          desc="按现场类型分区，想追哪条线就点哪条线。"
          align="center"
        />
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {list.map((topic, index) => (
            <Link
              key={topic.slug}
              to={`/live?cat=${topic.slug}`}
              className={`group flex cursor-pointer flex-col rounded-lg border p-5 transition-colors ${
                index === 0
                  ? "border-primary-300 bg-primary-50 hover:border-primary-400"
                  : "border-background-200 bg-background-100 hover:border-primary-300"
              }`}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-background-50 text-primary-600">
                <i className={`${topic.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {topic.name}
              </h3>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">{topic.desc}</p>
              <span className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span>{topic.count} 篇内容</span>
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}